import {Locale} from '../constants'
import {doStripEmptyStrings, transformMessages} from './transformMessages'

const fetchNamespace = async (locale: Locale, namespace: string) => {
  // Versioned per build: nginx sends no Cache-Control, so a browser could otherwise keep reusing
  // the previous deploy's copy, without keys the new code asks for
  const url = `/locales/${locale}/${namespace}.json?v=${process.env.NEXT_PUBLIC_COMMIT_ID ?? ''}`
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Failed to load ${url}: ${response.status}`)
  }
  return transformMessages(await response.json())
}

// Browser-side counterpart of `ensureMessages()` for a namespace loaded on demand: same transform,
// and the same fallback to English for keys a locale has no (or an empty) translation for.
export const loadNamespace = async (locale: Locale, namespace: string) => {
  const [defaultMessages, localeMessages] = await Promise.all([
    fetchNamespace(Locale.en, namespace),
    locale === Locale.en ? {} : fetchNamespace(locale, namespace).then(doStripEmptyStrings),
  ])

  return {[namespace]: {...defaultMessages, ...localeMessages}}
}
